import { CalendarDays } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import { useNewsPosts } from "@/hooks/useNewsPosts";
import { useCmsContent } from "@/hooks/useCmsContent";

const HomeNews = () => {
  const { t } = useLanguage();
  const { get } = useCmsContent();
  const news = t.homeNews;
  const { posts, hasPosts } = useNewsPosts();

  return (
    <section className="py-12 md:py-16 bg-primary">
      <div className="hotel-container">
        <div className="text-center mb-8">
          <p className="hotel-caption text-accent mb-3 tracking-[0.3em]">
            {get("news_caption") || news.caption}
          </p>
          <h2 className="font-display text-2xl md:text-3xl lg:text-4xl font-light text-primary-foreground">
            {get("news_heading") || news.heading}
          </h2>
          <div className="flex items-center justify-center gap-3 mt-4 mb-6">
            <span className="w-10 h-px bg-accent" />
            <span className="w-1.5 h-1.5 rotate-45 border border-accent" />
            <span className="w-10 h-px bg-accent" />
          </div>
        </div>

        {hasPosts ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {posts.map((post) => (
              <div key={post.id} className="bg-primary-foreground/10 rounded-lg overflow-hidden">
                {post.image_url && (
                  <img src={post.image_url} alt={post.title} loading="lazy" className="w-full h-48 object-cover" />
                )}
                <div className="p-5">
                  <h3 className="font-display text-lg font-semibold text-primary-foreground mb-2">{post.title}</h3>
                  <p className="font-body text-sm text-primary-foreground/80 line-clamp-3">{post.content}</p>
                  <p className="font-body text-xs text-accent mt-3">
                    {new Date(post.created_at).toLocaleDateString("de-CH")}
                  </p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="flex items-center justify-center gap-2 text-accent">
            <CalendarDays className="w-5 h-5" strokeWidth={1.5} />
            <p className="font-body text-sm md:text-base text-primary-foreground/80 italic">
              {news.comingSoon}
            </p>
          </div>
        )}
      </div>
    </section>
  );
};

export default HomeNews;
